import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-future-of-data-science',
  templateUrl: './future-of-data-science.component.html',
  styleUrls: ['./future-of-data-science.component.scss']
})
export class FutureOfDataScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
